import * as React from "react"

import "./top_nav.scss"

const TopNav = () => {

  return (
    <div className="top-nav bg-primary text-end py-1">
      <div className="container justify-content-end">
        <a href="https://portal.doctorgenius.com/login" className="top-nav-link text-white ps-3 pe-3">Log in</a>
        <a href="/contact" className="top-nav-link text-white ps-3">Contact</a>
        <a href="tel:877-477-2311" className="top-nav-link text-white ps-3">1.877.477.2311</a>
      </div>
    </div>
  )
}

export default TopNav